import api from './api'

/** Resolve avatar URL - prepend API base for relative paths (e.g. /uploads/...) */
export function getAvatarUrl(avatar: string | null | undefined): string | undefined {
  if (!avatar || typeof avatar !== 'string' || !avatar.trim()) return undefined
  if (avatar.startsWith('http://') || avatar.startsWith('https://') || avatar.startsWith('data:')) {
    return avatar
  }
  const base = (api.defaults.baseURL || '').replace(/\/api\/?$/, '')
  return base ? `${base}${avatar.startsWith('/') ? '' : '/'}${avatar}` : avatar
}
